module.exports = __webpack_public_path__ + "static/media/manage-privacy-preferences.8df0991c.png";